import { CloseIcon } from "@chakra-ui/icons"
import {
  Box,
  Button,
  Flex,
  Input,
  InputGroup,
  InputLeftAddon,
  InputLeftElement,
  Text,
} from "@chakra-ui/react"
import { useState } from "react"

export function AlertTnt({ isOpen, onClose, error }) {
  const [loading, setLoading] = useState(false)


  return (
    <Flex
      display={isOpen ? "flex" : "none"}
      position="fixed"
      top="50%"
      left="50%"
      transform="translate(-50%, -50%)"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      zIndex={999}
    >
      <Box
        color="white"
        w="600px"
        h="200px"
        p={3}
        bg="#e9e9e9"
        transition="all 0.2s"
        fontFamily={"Roboto, sans-serif"}
        display="flex"
        justifyContent="center"
        alignItems="center"
        boxShadow="0px 0px 1px 0px rgba(0,0,0,0.75)"
        borderRadius="5px"
        flexDirection="column"
      >
        <CloseIcon
          position={"absolute"}
          right={"10px"}
          top={"10px"}
          cursor={"pointer"}
          color={"#95c620"}
          onClick={onClose}
        />
      <Text fontSize="20px" fontWeight="bold" color="#95c620">
        Atenção
      </Text>

      <Text fontSize="16px" color="#343434">
        {error} (TNT)
      </Text>
      </Box>
    </Flex>
  )
}
